import {
	serviceCluster as serviceClusterIcon,
	encodeMarker
} from "@/data/map-markers";
import { TinyColor } from "@ctrl/tinycolor";

export default function getServiceClusterIcon( size, color ) {
	const strokeColor = new TinyColor( color )
	.lighten( 20 )
	.toString();

	return encodeMarker(
		serviceClusterIcon( color, strokeColor, size )
	).content;
}
